import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://dbpheoxpvqwtotxtqpzc.supabase.co'; 
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRicGhlb3hwdnF3dG90eHRxcHpjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDk3OTExNzIsImV4cCI6MjA2NTM2NzE3Mn0.oGHyM3V6ikCjf-_jbTgEl6oCnrobpqybdFzstEGGpNc'; 

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
